import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: "AIzaSyDW-FdDVlI7_qFd7nhR3aenvZnDDGtqFRk",
  authDomain: "maruhill-89ede.firebaseapp.com",
  projectId: "maruhill-89ede",
  storageBucket: "maruhill-89ede.firebasestorage.app",
  messagingSenderId: "806581921710",
  appId: "1:806581921710:web:7d13f8210952f58995ca3f",
  measurementId: "G-K0EVTTDCPC"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const analytics = getAnalytics(app)

export { db, analytics }
export default app
